document.addEventListener("DOMContentLoaded", function () {
    class MultiCollage extends HTMLElement {
        constructor() {
            super();
            this.collageRows = this.querySelectorAll(".collage-rows");
            this.collageRowsItem = this.querySelectorAll(".collage-rows__item");
            this.navigation = this.querySelector(".collage-navigation__list");
            this.navigationWrapper = this.querySelector(".multi-collage__collage-navigation");
            this.navigationItemText = this.querySelectorAll(".collage-navigation__item-text");
            this.observer = null;

            if (!this.collageRowsItem.length || !this.navigationWrapper) return

        }

        connectedCallback() {
            this.initObserver();
            this.setSpaceTop();

            this.navigationItemText.forEach(navigatorItem => {
                const { dataset: { scroll } } = navigatorItem;
                const scrollSection = document.querySelector(`#${scroll}`);
                
                if (scroll && scrollSection) {
                    navigatorItem.addEventListener("click", () => this.scrollToSection(scrollSection))
                    return;
                }
                navigatorItem.addEventListener("click", () => {
                    
                    this.handleDisabledNavigation(true)
                    const { dataset: { observer } } = navigatorItem;
                    const activeRow = [...this.collageRowsItem].find(row => row.id == observer);
                    this.observer.disconnect();
                    this.scrollTo(activeRow);
                    this.handleChangeActiveClass(navigatorItem)
                    this.delay(750).then(() => {
                        this.initObserver();
                        this.handleDisabledNavigation(false)
                    });
                });
            });

            const throttledReInitObserver = this.throttle(this.reInitObserver.bind(this), 500);
            const throttledSetSpaceTop = this.throttle(this.setSpaceTop.bind(this), 500);
            window.addEventListener("resize", () => {
                throttledReInitObserver();
                throttledSetSpaceTop();
            });
        }

        reInitObserver() {
            if (this.observer) {
                this.observer.disconnect()
                this.initObserver();
            }
        }

        scrollToSection(scrollSection) {
            const elementTop = scrollSection.offsetTop;
            const elementHeight = scrollSection.offsetHeight;
            const windowHeight = window.innerHeight;        
            const scrollToPosition = elementTop + (elementHeight / 2) - (windowHeight / 2);

            window.scrollTo({
                top: scrollToPosition,
                behavior: 'smooth'
            });
        }

        setSpaceTop() {
            if (this.navigationWrapper) {
                this.collageRowsItem[0].style.setProperty('--space-top', -this.navigationWrapper.offsetHeight + 'px');
            }
        }

        throttle(fn, delay) {
            let lastCall = 0;
            return function (...args) {
                const now = new Date().getTime();
                if (now - lastCall < delay) {
                    return;
                }
                lastCall = now;
                return fn(...args);
            };
        }

        initObserver() {
            this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.getConfigObserver());
            this.collageRows.forEach(row => this.observer.observe(row));
        }

        getConfigObserver() {
            return {
                threshold: window.innerWidth < 768 ? 0.1 : 1
            }
        }
        handleIntersection(entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.handleChangeActiveMenu(entry.target);
                }
            });
        }

        handleChangeActiveMenu(activeRow) {
            const rowItem = activeRow?.querySelector(".collage-rows__item");
            if (!rowItem) return;
            const activeItemText = [...this.navigationItemText].find(itemText => itemText.dataset.observer === rowItem.id);
            this.handleChangeActiveClass(activeItemText)
        }

        scrollTo(targetSelector) {
            targetSelector?.scrollIntoView({ behavior: "smooth" });
        }

        delay(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        }

        handleDisabledNavigation(isDisabled) {
            this.navigation.classList.toggle("collage-navigation__list--disabled", isDisabled)
        }

        handleChangeActiveClass(activeElement) {
            this.navigationItemText.forEach(itemText => itemText.classList.remove("collage-navigation__item-text--active"));
            if (activeElement) {
                activeElement.classList.add("collage-navigation__item-text--active");
            }
        }
    }

    if (!customElements.get("multi-collage")) {
        customElements.define("multi-collage", MultiCollage);
    }
});
